<script>
import axios from 'axios';
import * as moment from 'moment'

export default {
  data: () => ({
    busyLoading: false,

    rows: [],

    importButtonText: 'Bulk Import Collection Records',
    localImportUrl: localStorage.getItem('bulk-import-layers-collection-url'),
  }),

  computed: {
    importUrl: {
      get() { return this.localImportUrl },
      set(value) { this.localImportUrl = value; localStorage.setItem('bulk-import-layers-collection-url', value) },
    },

    hasRows() { return this.rows && this.rows.length > 0 },
  },

  methods: {
    async loadCollectionSheet() {
      this.busyLoading = true;
      this.rows = [];

      try {
        let response = await axios.get(this.importUrl);
        this.rows = this.processCollectionCsv(response.data.values);
      } finally {
        this.busyLoading = false;
      }
    },

    processCollectionCsv(data) {
      let headers = data.splice(0, 1)[0];
      let rows = data;

      let headerNames = {
        Batch: 'Batch',
        Date: 'Date',
        Person: 'Person',
        NumberOfEggs: 'Number of eggs',
        FoodBucketWeight: 'Bucket weight',
        PrePeakWeight: 'Pre-Peak',
        Mortalities: 'Mortalities',
      }

      let headerIndexes = {};
      Object.keys(headerNames).forEach(x => { headerIndexes[headerNames[x]] = headers.indexOf(headerNames[x]) });

      let missingHeadersKeys = Object.keys(headerIndexes).map(x => ({ key: x, index: headerIndexes[x] })).filter(x => x.index === -1).map(x => x.key);
      if (missingHeadersKeys.length > 0) {
        console.error('Missing headers!', missingHeadersKeys);
        alert(`Missing data headers ${missingHeadersKeys.join(', ')}`);
        return [];
      }

      let products = rows
        .map(x => {
          return {
            batch: x[headerIndexes[headerNames.Batch]],
            date: moment.utc(x[headerIndexes[headerNames.Date]], 'DD/MM/YYYY').format('YYYY-MM-DD'),
            person: x[headerIndexes[headerNames.Person]],
            number_of_eggs: x[headerIndexes[headerNames.NumberOfEggs]] || 0,
            food_bucket_weight_kg: x[headerIndexes[headerNames.FoodBucketWeight]] || 0,
            pre_peak_weight_kg: x[headerIndexes[headerNames.PrePeakWeight]] || 0,
            mortalities: x[headerIndexes[headerNames.Mortalities]] || 0,
          };
        });

      return products;
    },

    onSuccessfullyImported() {
      alert('Successfully imported');
      this.rows = [];
    },
  },
}
</script>

<template>
  <div>
    <form @submit.prevent="loadCollectionSheet">
      <b-input-group>
        <b-form-input v-model="importUrl" />
        <b-input-group-append>
          <b-button type="submit" variant="success" :disabled="!importUrl">
            <b-spinner v-if="busyLoading" small />
            Load Sheet
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </form>

    <div v-if="hasRows">
      <b-alert variant="success" show fade class="mt-3">
        Successfully loaded rows. Double-check data in the table below and click the '{{importButtonText}}' button below.
      </b-alert>

      <div class="table-responsive">
        <table class="table table-bordered table-sm small">
          <thead>
            <th> Batch </th>
            <th> Date </th>
            <th> Person </th>
            <th> NumberOfEggs </th>
            <th> Food Bucket Weight (kg) </th>
            <th> Pre-Peak Weight (kg) </th>
            <th> Mortalities </th>
          </thead>
          <tr v-for="(row, index) in rows" :key="index">
            <td>{{row.batch}}</td>
            <td>{{row.date}}</td>
            <td>{{row.person}}</td>
            <td>{{row.number_of_eggs || ''}}</td>
            <td>{{row.food_bucket_weight_kg || ''}}</td>
            <td>{{row.pre_peak_weight_kg || ''}}</td>
            <td>{{row.mortalities || ''}}</td>
          </tr>
        </table>
      </div>

      <confirm-click>
        <api-button
          method="put"
          url="v1/layeradmin/bulk-import-collection-records"
          :payload="{ rows: rows }"
          class="btn btn-success btn-block"
          :disabled="!importUrl"
          @executed="onSuccessfullyImported">
          <i class="fa fa-upload"></i>
          {{importButtonText}} ({{rows.length}} rows)
        </api-button>
      </confirm-click>

    </div>

  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/BulkImportCollectionRecords.vue